var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center min-vh-100"},[_c('div',{staticClass:"m-auto d-grid text-center"},[_c('img',{staticClass:"m-auto w-50",attrs:{"src":require("@/assets/img/icon/oops.png"),"alt":"no data","title":"no data"}}),_c('h2',{staticClass:"text-heading"},[_vm._v("Belum ada catatan")])])])
}]

export { render, staticRenderFns }